<template>
  <div>
    <!-- Icona dell'immagine -->
    <v-btn
      @click="dialog_aggiungi_allegato = true"
      icon
      v-if="
        (immagine_miniatura === '' ||
          immagine_miniatura === null ||
          immagine_miniatura === undefined) &&
        !isPdf(immagine_miniatura)
      "
    >
      <v-icon color="primary" x-large>mdi-image-plus</v-icon>
    </v-btn>

    <!-- Icona del PDF -->
    <div style="display: inline-block" v-if="isPdf(immagine_miniatura)">
      <v-icon
        @click="openPdfAppenaCaricato(immagine_miniatura)"
        color="error"
        x-large
      >
        mdi-file-pdf-box
      </v-icon>
    </div>

    <!-- Miniatura (immagine) -->
    <div
    class="elevation-2"
      :style="{
        borderRadius: '15px',
        display: 'inline-block',
        marginTop: '5px',
      }"
      v-if="immagine_miniatura != '' && !isPdf(immagine_miniatura)"
    >
      <img
        aspect-ratio="1"
        class="grey lighten-2"
        @click="showImageViewer"
        :lazy-src="immagine_miniatura"
        :src="immagine_miniatura"
        style="border-radius:15px;height: 100% !important; width: 100%; display: block !important"
      />
    </div>

    <!-- Bottoni di gestione della miniatura -->
    <div
      style="bottom: 5px; display: inline-block; position: relative"
      v-if="immagine_miniatura != ''"
    >
      <!-- Bottone di modifica immagine -->
      <div
        @click="dialog_aggiungi_allegato = true"
        style="display: inline-block"
      >
        <v-icon color="primary" small> mdi-pencil </v-icon>
      </div>

      <!-- Bottone di cancellazione immagine per la miniatura -->
      <div @click="eliminaImmagine" style="display: inline-block">
        <v-icon color="primary" small> mdi-image-off </v-icon>
      </div>
    </div>

    <!-- Dialog to Add new File to Articolo -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialog_aggiungi_allegato"
      width="500"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Associazione Miniatura
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-n4"
                @click="dialog_aggiungi_allegato = false"
                small
              >
                <v-icon v-on="on" v-bind="attrs" depressed color="error">
                  mdi-window-close
                </v-icon>
              </v-btn>
            </template>
            <span>Cancellare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-file-input
            accept="*"
            @change="onFileChange(img_allegata)"
            style="display: inline-block; width: 400px"
            type="file"
            v-model="img_allegata"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- to visualize the pdf dialog -->
    <v-dialog content-class="artDialog" v-model="pdfdialog" width="unset">
      <iframe
        :src="immagine_miniatura"
        frameborder="0"
        style="height: 80vh !important; width: 90vw !important"
      >
      </iframe>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    SnackbarQV,
  },
  props: {
    altezza_miniatura: {
      type: Number,
      default: 0,
    },
    id_referente: {
      type: Number,
      default: null,
    },
    immagine_full: {
      type: String,
      default: "",
    },
    immagine_miniatura: {
      type: String,
      default: "",
    },
    larghezza_miniatura: {
      type: Number,
      default: 0,
    },
    tipo_allegato: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      image_for_viewer: "",
      image_for_viewer_extension: "",
      image_for_viewer_name: "",
      immagine_preview: "",
      img_allegata: null,
      nuova_immagine_presente: false,

      // Modal
      dialog_aggiungi_allegato: false,
      pdfdialog: false,

      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    eliminaImmagine() {
      this.$emit("scelta_immagine", {
        be_call_needed: false,
        img_estensione: "",
        img_full: "",
        img_nome: "",
        img_miniatura: "",
      });
    },
    hasExtension(file, exts) {
      return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
        file.name
      );
    },
    isPdf(elem) {
      if (elem) {
        if (elem.startsWith("data:application/pdf")) {
          return true;
        } else {
          return false;
        }
      }
    },
    onFileChange(val) {
      if (
        this.hasExtension(val, [
          ".gif",
          ".jpeg",
          ".JPEG",
          ".jpg",
          ".JPG",
          ".pdf",
          ".png",
          ".PNG",
        ])
      ) {
        let that = this;
        let reader = new FileReader();

        reader.onload = function () {
          /* Solo se si tratta di un'immagine raster, metto a
           * true il semaforo per sapere che c'è un nuovo allegato.
           * Se invece l'allegato non è un raster ma un pdf, non ho bisogno
           * di salvarlo nella cartella degli allegati del BE. */

          if (that.hasExtension(val, [".pdf"])) {
            /* Se il file è un PDF lo registro senza comprimerlo e
             * assegno i debiti valori alle variabili di supporto. */
            const immagine_preview = reader.result;
            const image_for_viewer_name = val.name;
            const image_for_viewer_extension = val.name.split(".")[1];

            // Emetto un evento per aggiornare l'oggetto di riferimento.
            that.$emit("scelta_immagine", {
              be_call_needed: false,
              img_estensione: image_for_viewer_extension,
              img_full: immagine_preview,
              img_nome: image_for_viewer_name,
              img_miniatura: immagine_preview,
            });
          } else {
            let image = new Image();

            image.onload = function () {
              /* Registro l'immagine non compressa e assegno i
               * debiti valori alle variabili di supporto. */
              const image_for_viewer = image.src;
              const image_for_viewer_name = val.name;
              const image_for_viewer_extension = val.name.split(".")[1];

              let width, height;
              let ratio = image.width / image.height;

              if (image.width > image.height) {
                width = Math.min(100, image.width);
                height = width / ratio;
              } else {
                height = Math.min(80, image.height);
                width = height * ratio;
              }

              let canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(image, 0, 0, width, height);

              const immagine_preview = ctx.canvas.toDataURL();

              that.$emit("scelta_immagine", {
                be_call_needed: true,
                img_estensione: image_for_viewer_extension,
                img_full: image_for_viewer,
                img_nome: image_for_viewer_name,
                img_miniatura: immagine_preview,
              });
            };

            image.src = reader.result;
          }
        };

        reader.onerror = function (error) {
          console.log("Error: ", error);
        };

        reader.readAsDataURL(val);
      } else {
        this.dialog_aggiungi_allegato = false;
        this.$refs.SnackbarQV.print("orange", "Formato file non valido");
      }
      this.dialog_aggiungi_allegato = false;
    },
    openPdfAppenaCaricato(item) {
      if (item.startsWith("data:application/pdf")) {
        this.pdfdialog = true;
      }
    },
    showImageViewer() {
      /* Se la mia variabile locale per i dati dell'allegato è
       * già valorizzata, carico questi dati. Se invece non è valorizzata
       * ma sono stato in grado di cliccare sulla miniatura, vuol dire che
       * in passato ho salvato un'immagine e quindi chiedo al BE di mandarmela. */
      if (this.immagine_full != "") {
        this.$viewerApi({
          options: {
            toolbar: true,
            url: "data-source",
            initialViewIndex: 0,
          },
          images: [{ "data-source": this.immagine_full }],
        });
      } else {
        const request = {
          controller: "Global",
          method: "POST",
          richiesta: {
            action: "getallegati",
            token: localStorage.user_token,
            id_riferimento: this.id_referente,
            tipo: this.tipo_allegato,
          },
        };

        this.overlay = true;

        this.$store
          .dispatch("api", request)
          .then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              const res_tmp =
                res.data.result.allegati[res.data.result.allegati.length - 1];

              const request2 = {
                controller: "Global",
                method: "POST",
                richiesta: {
                  action: "getbase64bypath",
                  token: localStorage.user_token,
                  path:
                    localStorage.dbname +
                    `_${this.tipo_allegato}_` +
                    this.id_referente +
                    "." +
                    res_tmp.estensione,
                },
              };

              this.overlay = true;
              this.$store
                .dispatch("api", request2)
                .then((res2) => {
                  this.overlay = false;
                  if (res2.status === 200) {
                    this.$emit("immagine_full", res2.data.result);

                    // L'immagine in alta definizione valorizza la mia variabile di supporto
                    this.$viewerApi({
                      options: {
                        toolbar: true,
                        url: "data-source",
                        initialViewIndex: 0,
                      },
                      images: [{ "data-source": res2.data.result }],
                    });
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                  }
                })
                .catch(() => {
                  this.overlay = false;
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );
                });
            }
          })
          .catch(() => {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>